module.exports = __webpack_public_path__ + "static/media/BIMBOS.77c99e9e.png";